export const DialogTheme = {
    Modal: {
        defaultProps: {
            size: "md",
        },
        sizes: {
            "xs": {
                contentSize: {
                    maxWidth: "90%",
                    width: 400,
                },
            },
            "sm": {
                contentSize: {
                    width: '50%',
                    maxWidth: "none",
                },
            },
            "md": {
                contentSize: {
                    width: '65%',
                    maxWidth: "none",
                },
            },
            "lg": {
                contentSize: {
                    width: '75%',
                    maxWidth: "none",
                },
            },
            "xl": {
                contentSize: {
                    width: '85dvw',
                    maxWidth: "none",
                },
            },
            "full": {
                contentSize: {
                    width: '100%',
                    maxWidth: "none",
                },
            },
            "fullScreen": {
                justifyContent: "unset",
                alignItems: "unset",
                contentSize: {
                    width: '100%',
                    maxWidth: "100dvh",
                    minHeight: "100dvh",
                    maxHeight: "100dvh",
                },
            },
            "auto": {
                contentSize: {
                    width: 'auto',
                    maxWidth: "none",
                },
            },
        }
    },
    ModalContent: {
        baseStyle: ({ colorMode }) => {
            return {
                bg: `${colorMode}.50`,
            }
        },
        defaultProps: {
            shadow: 5,
        }
    },
    ModalHeader: {
        baseStyle: {
            fontSize: 'lg',
        },
    }
}